import React from //useState,
//useEffect,
//useMemo,
'react';

// import {
// 	useSelector,
// 	useDispatch
// } from 'react-redux';

import { GenericDictSelect } from './genericDictSelect.js';

export const AnimalGenderSelect = (props) => {
	let types = {
		M: 'Bulls',
		N: 'Steers',
		F: 'Heifers / Cows',
		X: 'Mixed',
	};

	if (props.species === 'Sheep') {
		types = {
			M: 'Rams',
			N: 'Wethers',
			F: 'Ewes',
			X: 'Mixed',
		};
	}

	return (
		<>
			<GenericDictSelect
				id="Sex"
				label="Sex"
				required={props.required}
				dataDict={types}
				cols={props.cols}
				controlStyle={props.controlStyle}
				handleChange={(evt) => props.handleChange(evt)}
				value={props.value}
				//pattern = {'^\d+$'}	// integer
				pattern={'^[a-zA-Z]+[a-zA-Z/]+$'}
				invalidMsg="Select Animal sex!"
				selectDotDotDot={true}
				lock={props.lock}
				loading={false}
			/>
		</>
	);
};
